module.exports = __webpack_public_path__ + "static/img/main_logo_white.994d700.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cereshop/home/main_logo_white.png
// module id = EFYr
// module chunks = 18